import React from 'react';
import SiteSearchStore from './store';
import { SiteSearch } from './SiteSearchWidget';
import { widget } from '@widgets/core';
export var SiteSearchWidget = widget('sitesearch')(function () { return new SiteSearchStore; }, function (store, tracker) {
    return (React.createElement(SiteSearch, { destinationURL: store.config.destinationURL, additionalParams: store.config.additionalParams, searchParams: store.config.searchParams, store: store, tracker: tracker }));
});
export default SiteSearchWidget;
